export default "__VITE_ASSET__BmaNlJaZ__"